<script>
import { BCard, BFormDatepicker, BFormInput, BFormGroup, BRow, BCol, BFormCheckbox } from 'bootstrap-vue'
import Overlay from "@core/components/common/Overlay.vue";
import {SubstanceApi} from "@core/api";
import backendResponse from "@core/mixins/ui/backend-response";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'
import vSelect from 'vue-select'
import {RegulatedProperties} from "@/views/administration/substance/regulated-substances/regulated-properties";
import Button from "@core/components/common/Button.vue";
import {RegulatedPropertyType} from "@core/domain/substance";
import LocalizedQuestions from "@/views/administration/substance/regulated-substances/LocalizedQuestions.vue";

export default {
    mixins: [backendResponse],
    components: {
        LocalizedQuestions, Button, RegulatedProperties, BFormDatepicker, BFormCheckbox,
        Overlay, BCard, BRow, BCol, BFormInput, BFormGroup, AppCollapse, AppCollapseItem, vSelect
    },
    props: {
        id: {
            required: true,
        }
    },
    data() {
        return {
            showLoading: true,
            comparisonOperators: ['<', '<=', '>', '>='],
            concentrationUnits: ['w/w', 'ppm'],
            card: {
                substance: {
                    title: null,
                    cas: null,
                    ec: null,
                    echaId: null
                },
                lists: []
            }
        }
    },
    methods: {
        onRegulatedPropertiesChange(list, propertyType, properties) {
            const listContainer = this.card.lists.find(container => container.list.key === list.key);

            if (!listContainer) {
                return;
            }

            if (!listContainer.regulatedProperties[propertyType]) {
                listContainer.regulatedProperties[propertyType] = [];
            }

            listContainer.regulatedProperties[propertyType] = properties;
        },

        removeRegulatedPropertyItem(list, property, propertyItem) {
            const index = property.rows.findIndex(r => r === propertyItem);
            if (index > -1) {
                property.rows.splice(index, 1);
            }
        },

        save() {
            this.showLoading = true;
            const data = {
                substance: {
                    name: this.card.substance.title,
                    echaId: this.card.substance.echaId,
                    ec: this.card.substance.ec,
                    cas: this.card.substance.cas,
                },
                lists: this.card.lists.map(listData => {
                    const data = {
                        list: listData.list.id,
                        properties: listData.properties,
                        regulatedProperties: {},
                        localizedQuestions: listData.localizedQuestions
                    };

                    Object.keys(listData.regulatedProperties).forEach(key => {
                        data.regulatedProperties[key] = listData.regulatedProperties[key].map(item => {
                            return {
                                coveredExcluded: item.coveredExcluded,
                                property: {
                                    id: item.property.id
                                }
                            };
                        });
                    });

                    return data;
                })
            };
            SubstanceApi
                .saveCard(this.id, data)
                .then(r => {
                    this.showDefaultSuccessMessage('Successfully saved');
                })
                .catch(this.handleBackendError)
                .finally(() => this.showLoading = false);
        },

        close() {
            this.$router.go(-1);
        },

        localizedQuestionChanged(list, data) {
            list.localizedQuestions = data;
        }
    },
    created() {
        SubstanceApi
            .getCard(this.id)
            .then(r => {
                r.data.lists.forEach(container => {
                    const regulatedProperties = {};
                    RegulatedPropertyType.all().forEach(propertyType => {
                        regulatedProperties[propertyType] = container.regulatedProperties.hasOwnProperty(propertyType)
                            ? container.regulatedProperties[propertyType]
                            : [];
                    });
                    container.regulatedProperties = regulatedProperties;
                });
                this.card = r.data;
            })
            .catch(this.handleBackendError)
            .finally(() => this.showLoading = false)
    }
}
</script>

<template>
    <Overlay :show="showLoading">
        <b-row class="mb-1">
            <b-col md="6" lg="6">
                <h4>Edit {{ card.substance.title }}</h4>
            </b-col>
            <b-col md="6" lg="6" class="text-right">
                <Button
                    class="mr-1"
                    @click="save"
                >
                    {{ $t('Component(Button):save') }}
                </Button>
                <Button @click="close">
                    {{ $t('Component(Button):close') }}
                </Button>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-card :title="$t('Component(Text):general-info')">
                    <b-row>
                        <b-col>
                            <b-form-group
                                :label="$t('Component(Label):name')"
                                label-for="name"
                            >
                                <b-form-input
                                    id="name"
                                    v-model="card.substance.title"
                                    :placeholder="$t('Component(Label):name')"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col>
                            <b-form-group
                                :label="$t('Component(Label):echa-id')"
                                label-for="echaId"
                            >
                                <b-form-input
                                    id="echaId"
                                    v-model="card.substance.echaId"
                                    :placeholder="$t('Component(Label):echa-id')"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                :label="$t('Component(SubstanceTable):column-cas')"
                                label-for="cas"
                            >
                                <b-form-input
                                    id="cas"
                                    v-model="card.substance.cas"
                                    :placeholder="$t('Component(SubstanceTable):column-cas')"
                                />
                            </b-form-group>
                        </b-col>
                        <b-col>
                            <b-form-group
                                :label="$t('Component(SubstanceTable):column-ec')"
                                label-for="ec"
                            >
                                <b-form-input
                                    id="ec"
                                    v-model="card.substance.ec"
                                    :placeholder="$t('Component(SubstanceTable):column-ec')"
                                />
                            </b-form-group>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <app-collapse
                    type="margin"
                >
                    <app-collapse-item
                        v-for="list in card.lists"
                        :title="list.list.title"
                    >
                        <b-row>
                            <b-col>
                                <LocalizedQuestions
                                    :localized-questions="list.localizedQuestions"
                                    @input="(data) => localizedQuestionChanged(list, data)"
                                />
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <b-form-group
                                    :label="$t('Component(CompositionSubstance):max-concentration')"
                                    label-for="max-concentration"
                                >
                                    <b-form-input
                                        id="max-concentration"
                                        v-model="list.properties.maxConcentration"
                                        type="number"
                                        :placeholder="$t('Component(CompositionSubstance):max-concentration')"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    :label="$t('Component(Label):unit')"
                                    :label-for="'unit'+list.list.id"
                                >
                                    <v-select
                                        v-model="list.properties.unit"
                                        :options="concentrationUnits"
                                        :clearable="false"
                                        :id="'unit'+list.list.id"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col>
                                <b-form-group
                                    :label="$t('Component(Label):comparison-operator')"
                                    :label-for="'operator'+list.list.id"
                                >
                                    <v-select
                                        v-model="list.properties.comparisonOperator"
                                        :options="comparisonOperators"
                                        :clearable="false"
                                        :id="'operator'+list.list.id"
                                    />
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col md="4" lg="4">
                                <b-form-group
                                    :label="$t('Component(Label):valid-from')"
                                    label-for="inclusion-date"
                                >
                                    <b-form-datepicker
                                        id="inclusion-date"
                                        v-model="list.properties.inclusionDate"
                                        :placeholder="$t('Component(Label):valid-from')"
                                        :date-format-options="$store.state.component.datePicker.format"
                                        :locale="$store.state.component.datePicker.locale"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="4">
                                <b-form-group
                                    :label="$t('Component(Label):valid-to')"
                                    label-for="exclusion-date"
                                >
                                    <b-form-datepicker
                                        id="exclusion-date"
                                        v-model="list.properties.exclusionDate"
                                        :placeholder="$t('Component(Label):valid-to')"
                                        :date-format-options="$store.state.component.datePicker.format"
                                        :locale="$store.state.component.datePicker.locale"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="4" lg="4" class="align-items-center d-flex">
                                <div class="demo-inline-spacing">
                                    <b-form-checkbox
                                        v-model="list.properties.selectable"
                                    >
                                        {{ $t('Component(Text):selectable') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="list.properties.searchable"
                                    >
                                        {{ $t('Component(Text):searchable') }}
                                    </b-form-checkbox>
                                    <b-form-checkbox
                                        v-model="list.properties.allowed"
                                    >
                                        {{ $t('Component(Text):allowed') }}
                                    </b-form-checkbox>
                                </div>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col>
                                <RegulatedProperties
                                    :list="list.list"
                                    :properties="list.regulatedProperties"
                                    @change="onRegulatedPropertiesChange"
                                    @removePropertyItem="removeRegulatedPropertyItem"
                                />
                            </b-col>
                        </b-row>
                    </app-collapse-item>
                </app-collapse>
            </b-col>
        </b-row>
    </Overlay>
</template>
